export { default } from "./AdminConsoleFacultyAdderModalContent";
